export const STRINGS = {
  title: 'Download our app to continue your Belong experience!',
  subtitle:
    'Managing your home just got even easier. Use the app to track earnings, stay up to date on your home, and more.',
  cta: 'Go to account',
};
